import Entity from '../entity'
import Address from '../address'

export default class TplDetail extends Entity<string>{
    name:string;
    contactAddressId:number;
    contactName: string;
    contactPhone:string;
    isActive: boolean;
    shortName:string;
    contactAddress: Address=new Address();
    fullAddress:string;
    isActiveText:string;
    creationTime: Date;
    creatorUserName:string;
    isRequiredInvoiceNo:boolean;
    type:string;
    licensePlate:string;
    weight:number;
    volume:number;
}